import { ACTIVE_COHORTS, DEFAULT_COHORT, REMOVED_COHORTS } from 'root-constants'

export const resolveCohort = (cohortFromUrl: string): string => {
  if (
    !cohortFromUrl ||
    REMOVED_COHORTS.includes(cohortFromUrl) ||
    !ACTIVE_COHORTS.includes(cohortFromUrl)
  ) {
    return DEFAULT_COHORT
  }

  return cohortFromUrl
}
